import { lazy } from "react";
import ProtectedAuth from "./PrivateAuth";
import Blog from "../Views/Main/Content";
import UpdateContent from "../Views/Main/Content/UpdateContent";
import EnquiryDetails from "../Views/Main/Enquiry";
import AddMatchContent from "../Views/Main/AddMatch";
import Offers from "../Views/Main/Offers";
import UpdateOffer from "../Views/Main/Offers/AddOffer";
import Banners from "../Views/Main/Banner";
import UpdateBanner from "../Views/Main/Banner/AddBanner";
import Casino from "../Views/Main/Casino";
import UpdateCasino from "../Views/Main/Casino/AddCasino";
import Subscriber from "../Views/Main/Subscriber";
import AddSubscriber from "../Views/Main/Subscriber/AddSubscriber";
import User from "../Views/Main/User";
import EditUser from "../Views/Main/User/EditUser";
import News from "../Views/Main/News";
import AddNews from "../Views/Main/News/AddNews";
import Blogs from "../Views/Main/Blog";
import AddBlog from "../Views/Main/Blog/AddBlog";
import Poster from "../Views/Main/Poster";
import AddPoster from "../Views/Main/Poster/AddPoster";
import Advertisements from "../Views/Main/Advertisements";
import AddAdvertisements from "../Views/Main/Advertisements/AddAdvertisements";

export const PrivateAuth = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/content/contentData",
          element: <Blog />,
        },
        {
          path: "/content/addContent",
          element: <UpdateContent />,
        },
        {
          path: "/add/match_content",
          element: <AddMatchContent />,
        },
        {
          path: "/get/enquiry_details",
          element: <EnquiryDetails />,
        },
        {
          path: "/get/offers_details",
          element: <Offers />,
        },
        {
          path: "/offer/add_offer",
          element: <UpdateOffer />,
        },
        {
          path: "/get/casino_details",
          element: <Casino />,
        },
        {
          path: "/casino/add_casino",
          element: <UpdateCasino />,
        },
        {
          path: "/get/banner_details",
          element: <Banners />,
        },
        {
          path: "/banner/add_banner",
          element: <UpdateBanner />,
        },
        {
          path: "/get/subscriber_details",
          element: <Subscriber />,
        },
        {
          path: "/subscriber/add_subscriber",
          element: <AddSubscriber />,
        },
        {
          path: "/get/user_details",
          element: <User />,
        },
        {
          path: "/user/edit_user",
          element: <EditUser />,
        },
        {
          path: "/get/news_details",
          element: <News />,
        },
        {
          path: "/news/add_news",
          element: <AddNews />,
        },
        {
          path: "/get/blog_details",
          element: <Blogs />,
        },
        {
          path: "/blog/add_blog",
          element: <AddBlog />,
        },
        {
          path: "/get/poster_details",
          element: <Poster />,
        },
        {
          path: "/poster/add_poster",
          element: <AddPoster />,
        },
        {
          path: "/get/advertisements_details",
          element: <Advertisements />,
        },
        {
          path: "/advertisements/add_advertisements",
          element: <AddAdvertisements />,
        },
        {
          path: "*",
          element: <Blog />,
        },
      ],
    },
  ];
};
